import { Chip } from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

export const tableHeaderFn = ({ setStudent }) => [
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'totalSessions',
    headerName: 'Session Count',
    width: 180,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ value, row }) => `${value}/${row?.classTaken}`,
  },
  {
    field: 'action',
    headerName: 'Action',
    width: 160,
    renderCell: ({ row }) => (
      <Chip
        sx={{
          cursor: 'pointer',
        }}
        label={'View'}
        color="primary"
        variant="outlined"
        icon={<RemoveRedEyeOutlinedIcon color="inherit" />}
        onClick={() => setStudent(row)}
      />
    ),
  },
  {
    field: 'feedback',
    headerName: 'Feedback',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
];
